import Immutable from 'immutable';

export default {
  // eslint-disable-next-line no-unused-vars
  onSaveFieldCompleted(field, value) {
    //TODO..
  },

  onUpdateField(field, value) {
    this._updateFieldState(field, value);
  },

  _updateFieldState(field, value) {
    this.setStateAndTrigger(this.getState().set(field, value));

    if (this.setFieldValidationState) {
      if (field === 'teamPhoneNumber') {
        let phone = value.replace(/[-+)(\s]/g, '');
        this.setFieldValidationState(field, phone);
        return;
      }
      this.setFieldValidationState(field, value);
    }
  },

  onSubmit() {
    this.setSubmitState(true);
  },

  setLoading(isLoading) {
    this.setStateAndTrigger(
      this.getState()
        .set('loading', isLoading)
        .set('submitButtonText', isLoading ? 'Loading..' : undefined),
    );
  },

  setSubmitState(isSubmitted) {
    this.setStateAndTrigger(
      this.getState()
        .set('submitted', isSubmitted)
        .set('submitButtonText', isSubmitted ? 'Working..' : undefined),
    );
  },

  clearForm() {
    this.setStateAndTrigger(Immutable.Map({}));
  },
};
